<div class="modal-header">
  <h5 class="modal-title" id="cancelSubscriptionModalHeader" i18n="@@CancelSubscriptionModalHeader">Abonnement kündigen</h5>
  <button type="button" id="cancel_subscription" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
    <div class="swal2-icon-content">!</div>
  </div>
  <h5>Sind Sie sicher?</h5>
</div>

<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" data-bs-dismiss="modal" i18n="@@CancelButton">Abbrechen</button>
  <button type="submit" id="confirm" class="btn btn-danger" (click)="onConfirm()" i18n="@@ConfirmCancelSubscriptionButton">Abonnement kündigen</button>
</div>
